import trashIcon from "../../assets/photo/trash.svg"
import trashIconWhite from "../../assets/photo/light_theme/trash.svg"
import downloadIcon from "../../assets/photo/download_mobile.svg"
import downloadIconWhite from "../../assets/photo/light_theme/download_mobile.svg"
import phyalbumIcon from "../../assets/photo/physical-album.svg"
import phyalbumIconWhite from "../../assets/photo/light_theme/physical_album.svg"
import shareIcon from "../../assets/photo/share.svg"
import shareIconWhite from "../../assets/photo/light_theme/share.svg"
import moveIcon from "../../assets/photo/move.svg"
import moveIconBlack from "../../assets/photo/light_theme/move.svg"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"
import { MySelector } from "../../redux/store"
import { setDeleteArray, setMoveFolderArray } from "../../redux/utilSlice"
import { useDispatch } from "react-redux"

const BottomBar = () => {
  const dispatch = useDispatch()

  const {
    selectedPhotos,
    type,
    currentFolderData,
    downloadData: { downloadEnabled },
  } = MySelector((state) => state.util)

  const { activeAlbumFiles } = MySelector((state) => state.gallery)
  const { theme } = MySelector((state) => state.theme)
  const { category } = MySelector((state) => state.event)

  const { shareFile, moveToPhysicalAlbum, downloadFile } = HandleAsyncFns()

  // Check if guest has any available actions
  const guestHasActions = category === "guest" && (downloadEnabled && type === "gallery")
  const hostHasActions = category === "host"
  const shouldShowBottomBar = selectedPhotos?.length > 0 && (guestHasActions || hostHasActions)

  return (
    <div
      className={`text-newDarkBlack dark:text-white bg-white/85 dark:bg-black/85 z-[5050] ${
        shouldShowBottomBar ? "grid" : "hidden"
      } lg:hidden ${
        type === "gallery"
          ? selectedPhotos?.length === 1
            ? category === "host"
              ? downloadEnabled
                ? "grid-cols-5"
                : "grid-cols-4"
              : downloadEnabled
              ? "grid-cols-2"
              : "grid-cols-1"
            : category === "host"
            ? downloadEnabled
              ? "grid-cols-4"
              : "grid-cols-3"
            : downloadEnabled
            ? "grid-cols-1"
            : "grid-cols-0"
          : "grid-cols-1"
      } font-[500] text-xl px-[16px] py-3 md:py-4 fixed bottom-0 w-full`}
      style={{
        backdropFilter: "blur(12px)",
      }}
    >
      {downloadEnabled && type === "gallery" && (
        <div
          onClick={() => {
            const sourceArray =
              type === "gallery" ? currentFolderData : activeAlbumFiles || []

            const filteredObjects = sourceArray.filter((item: { id: string }) =>
              selectedPhotos.includes(item.id)
            )

            const formattedObjects = filteredObjects.map(
              ({ url, name, compressedUrl }: { url: string; name: string; compressedUrl?: string }) => ({
                url: url || "",
                name: name || "",
                compressedUrl,
              })
            )

            downloadFile?.(formattedObjects)
          }}
          className="flex flex-col items-center gap-1.5"
        >
          <img
            src={theme === "dark" ? downloadIcon : downloadIconWhite}
            alt=""
            className="h-[22px] w-[22px] cursor-pointer"
          />
          <p className="text-xs font-light">Download</p>
        </div>
      )}


      {category === "host" && (
        <div
          onClick={() => dispatch(setDeleteArray?.(selectedPhotos))}
          className="flex flex-col items-center gap-1.5"
        >
          <img
            src={theme === "dark" ? trashIcon : trashIconWhite}
            className="h-[22px] w-[22px] cursor-pointer"
            alt=""
          />
          <p className="text-xs font-light">Remove</p>
        </div>
      )}

      {category === "host" && type === "gallery" && (
        <div
          onClick={() => moveToPhysicalAlbum?.(selectedPhotos)}
          className="flex flex-col items-center gap-1.5"
        >
          <img
            src={theme === "dark" ? phyalbumIcon : phyalbumIconWhite}
            alt=""
            className="h-[22px] w-[22px] cursor-pointer"
          />
          <p className="text-xs font-light">Album</p>
        </div>
      )}

      {category === "host" && type === "gallery" && (
        <div
          onClick={() => dispatch(setMoveFolderArray?.(selectedPhotos))}
          className="flex flex-col items-center gap-1.5"
        >
          <img
            src={theme === "dark" ? moveIcon : moveIconBlack}
            alt=""
            className="h-[22px] w-[22px] cursor-pointer"
          />
          <p className="text-xs font-light">Folder</p>
        </div>
      )}

      {type === "gallery" && selectedPhotos.length === 1 && (
        <div
          onClick={() => shareFile.setSharable?.(selectedPhotos[0])}
          className="flex flex-col items-center gap-1.5"
        >
          <img
            src={theme === "dark" ? shareIcon : shareIconWhite}
            alt=""
            className="h-[22px] w-[22px] cursor-pointer"
          />
          <p className="text-xs font-light">Share</p>
        </div>
      )}
    </div>
  )
}

export default BottomBar
